<template>
    <div>
        <div class="x-stat">
            <a-row>
                <a-col :span="3">
                    <a-statistic title="投注量" :value="stat.totalBetNum" />
                </a-col>
                <a-col :span="3">
                    <a-statistic title="投注金额" :value="stat.totalBetAmount" />
                </a-col>
                <a-col :span="3">
                    <a-statistic title="盈利" :value="stat.totalProfit" />
                </a-col>
            </a-row>
        </div>

        <a-card :bordered="false">
            <div class="x-filter">
                <a-form layout="inline">
                    <a-row :gutter="24">
                        <a-col :span="6">
                            <a-form-item label="时间">
                                <a-range-picker @change="onCreateTime" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="4">
							<span class="x-filter-submit-box">
								<a-button type="primary" @click="getTableData">查询</a-button>
								<a-button style="margin-left: 8px" @click="() => this.queryParams={}">重置</a-button>
							</span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>

            <a-table
                :rowKey="record => record.id"
                :columns="tableColumns"
                :loading="tableLoading"
                :dataSource="tableData"
                :pagination="false"
            >
                <div slot="user" slot-scope="record">
                    <span>{{ record.userLoginAccount }}</span>
                    -
                    <span>{{ record.userNickname }}</span>
                </div>

                <template slot="profit" slot-scope="record">
                    <span v-if="record.profit > 0" class="success">+{{ record.profit }}</span>
                    <span v-else-if="record.profit < 0" class="error">{{ record.profit }}</span>
                    <span v-else>{{ record.profit }}</span>
                </template>
            </a-table>

            <div class="x-pagination">
                <a-pagination
                    :pageSize="pageSize"
                    v-model="pageIndex"
                    :total="totalRow"
                    @change="pageChange"
                    :hideOnSinglePage="true"
                    show-less-items
                />
            </div>
        </a-card>
    </div>
</template>

<script>
import { platformStatList } from "@/api/finance/platformStat";
import moment from "moment/moment";

const tableColumns = [
    { title: '#', dataIndex: 'id' },
    { title: '日期', dataIndex: 'statDate' },
    { title: '参与人数', dataIndex: 'betUserNum' },
    { title: '投注量', dataIndex: 'betNum' },
    { title: '投注金额', dataIndex: 'betAmount' },
    { title: '盈利', scopedSlots: { customRender: 'profit' } },
    { title: '创建时间', dataIndex: 'created' }
];

export default {
    data() {
        return {
            stat: {
                totalBetNum: 0,
                totalBetAmount: 0,
                totalProfit: 0,
            },
            queryParams: {},
            tableLoading: false,
            tableColumns,
            totalRow: 0,
            tableData: [],
            pageSize: 20,
            pageIndex: 1,
        }
    },
    created() {
        this.getTableData();
    },
    methods: {
        onCreateTime(values) {
            this.queryParams.startCreateTime = moment(values[0]).unix();
            this.queryParams.endCreateTime = moment(values[1]).unix();
        },
        getTableData() {
            this.tableLoading = true;
            this.queryParams.pageSize = this.pageSize;
            this.queryParams.page = this.pageIndex;

            return platformStatList(this.queryParams).then((res) => {
                console.log(res.data.stat);
                this.stat = res.data.stat;
                this.tableData = res.data.recordList || [];
                this.totalRow = res.data.totalRow || 0;
            }).finally(() => {
                this.tableLoading = false;
            });
        },
        pageChange(current) {
            this.pageIndex = current;
            this.getTableData();
        },
    },
}
</script>

<style scoped>

</style>